"use client";
import * as React from "react";
const SvgArrowUpwardRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M9.03 14.97V3.5l5.01 5.01c.4.4 1.06.4 1.46 0s.4-1.04 0-1.44L8.74.3c-.4-.4-1.05-.4-1.45 0L.5 7.06A1.02 1.02 0 1 0 1.96 8.5l5.02-5v11.47A1.03 1.03 0 0 0 8 16a1.03 1.03 0 0 0 1.02-1.03" }));
export {
  SvgArrowUpwardRound as default
};
